/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Forced_TitleInputs */

const en_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced Subtitle`)
};

const fr_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titre force`)
};

const de_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungener Untertitel`)
};

const it_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli forzati`)
};

const ru_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительные субтитры`)
};

const es_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulo forzado`)
};

const zh_cn2_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制字幕`)
};

const ja_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕`)
};

const hi_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनिवार्य उपशीर्षक`)
};

const pt_pt2_event_forced_title = /** @type {(inputs: Event_Forced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda forçada`)
};

/**
* | output |
* | --- |
* | "Forced Subtitle" |
*
* @param {Event_Forced_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_forced_title = /** @type {((inputs?: Event_Forced_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Forced_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_forced_title(inputs)
	if (locale === "de") return de_event_forced_title(inputs)
	if (locale === "it") return it_event_forced_title(inputs)
	if (locale === "ru") return ru_event_forced_title(inputs)
	if (locale === "es") return es_event_forced_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_forced_title(inputs)
	if (locale === "ja") return ja_event_forced_title(inputs)
	if (locale === "hi") return hi_event_forced_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_forced_title(inputs)
	return en_event_forced_title(inputs)
});